export const STATES_HEADER_BASE_URL = "https://static.buscameaqui.com/site/headers/desktop/"
export const STATES_HEADER_EXT = ".png"

export const MOBILE_STATES_HEADER_BASE_URL = "https://static.buscameaqui.com/site/headers/mobile/"
